module.exports = __webpack_public_path__ + "static/img/291.da2418c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/291.png
// module id = lMpM
// module chunks = 0